import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useCopy } from 'common';
import { Callout } from '../../molecules';
export const SearchEmpty = memo(({ title, message }) => {
    const { widgets: { assetSearchNoResult }, } = useCopy();
    return (_jsx(Callout, { small: true, icon: "ManageSearch", variant: "secondary", title: title || assetSearchNoResult.title, message: message || assetSearchNoResult.subtitle }));
});
